//
// Toggle excess cards
//

(function () {
    //
    // Inspect the cards container
    //

    // Find the containers in the page
    const cardContainers = document.querySelectorAll("[data-cards-container]");

    cardContainers.forEach((container) => {
        // For each container determine the number of cards allowed
        const maxCards = container.getAttribute("data-max-cards");

        // Get an array of cards
        const cards = container.children;

        // Check if the component is expandable
        const isExpandable = container.getAttribute("data-is-expandable");

        // Append the button after the title only if there are cards in excess
        if (cards.length > maxCards && isExpandable === "true") {
            // Get the ID and the h2 to append the button after
            const containerId = container.getAttribute("aria-describedby");
            const h2 = document.getElementById(`${containerId}`);

            // Append the button with correct identification
            h2.insertAdjacentHTML("afterend", `<button class=" [ anchor ] " aria-expanded="false" aria-controls="${containerId}-expandable" data-expandable data-expandable-set="${containerId}-expandable" data-label="See all" data-label-expanded="See less">See all</button>`);
        }

        // Hide the cards in excess
        for (let i = maxCards; i < cards.length; i++) {
            cards[i].classList.add("card-excess");
            cards[i].classList.add("hidden");
        }
    });

    // Find the buttons in the page
    const buttons = document.querySelectorAll("[data-expandable]");

    // Toggle Button
    const toggleButton = (button, target, hide) => {
        if (typeof hide === "undefined") {
            hide = button.getAttribute("aria-expanded") === "true" || false;
        }
        button.setAttribute("aria-expanded", !hide);

        // Toggle the text of the button
        if (button.getAttribute("data-label") && button.getAttribute("data-label-expanded")) {
            button.innerText = !hide ? button.getAttribute("data-label-expanded") || button.innerText : button.getAttribute("data-label") || button.innerText;
        }

        // Show or hide the cards in excess by toggling the hidden class
        const hiddenCards = [...target.children].filter((child) => child.classList.contains("card-excess"));
        hiddenCards.forEach((card) => card.classList.toggle("hidden"));
    };

    // Get the correct target
    const getTarget = (button) => {
        const identifier = button.getAttribute("aria-controls") || button.id;
        return document.querySelector(`[aria-labelledby="${identifier}"]`);
    };

    buttons.forEach((button) => {
        // Assign the container to target with the button
        let target = getTarget(button);

        // Behaviour Clicking the button
        button.addEventListener("click", (event) => {
            event.preventDefault();

            // Treat multiple accordion as one
            if (button.getAttribute("data-expandable-set")) {
                const set = button.getAttribute("data-expandable-set");
                buttons.forEach((other) => {
                    if (other.getAttribute("data-expandable-set") === set) {
                        target = getTarget(other);
                        if (button !== other) {
                            toggleButton(other, target, false);
                        } else {
                            toggleButton(button, target);
                        }
                    }
                });
            } else if (button.getAttribute("data-expandable-unique") !== "false") {
                buttons.forEach((other) => {
                    target = getTarget(other);
                    if (button !== other) {
                        toggleButton(other, target, false);
                    } else {
                        toggleButton(button, target);
                    }
                });
            } else {
                toggleButton(button, target);
            }
        });
    });
})();
